import { render, staticRenderFns } from "./TransactionRecent.vue?vue&type=template&id=d3676a0c&"
import script from "./TransactionRecent.vue?vue&type=script&lang=js&"
export * from "./TransactionRecent.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRecent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports